export default __webpack_public_path__ + "static/media/arrow_top.543277ad.svg";